

import { getCostValue } from '@shootsta/cost-parsing-utils';
import { getAddonTotalCost } from '../../../utils';









export default function handleCostChange({
  costValue,
  selectedValue,
  setSelectedValue,
  onChangeAddon,
  setAddonTotalCost
}) {
  const oldCost = getCostValue(selectedValue);
  const reg = new RegExp(oldCost.toString());
  const newString = selectedValue.cost.replace(reg, costValue || 0);
  const updatedValue = { ...selectedValue, cost: newString };

  setAddonTotalCost(getAddonTotalCost({ selectedValue: updatedValue }));
  onChangeAddon(updatedValue);
  setSelectedValue(updatedValue);
}